import React, { Component } from 'react'
import cover from '../../../../assets/img/cover.png'
import dp from '../../../../assets/img/dp.png'
import './Student.css'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

class Student extends Component {
    render() {
        let picStyle = {
            backgroundColor: "red",
            width: "100px",
            height: "100px",
            borderRadius: "45px"
        }
        return (<div>
            {/* <div style={{ width: "100%", backgroundColor: "grey" }}>
                <div style={picStyle}>

                </div>
            </div>
            <h3>Name :{this.props.studentDetail.name}</h3>
            <h5>Roll No :{this.props.studentDetail.roll}</h5>
            <h5>Class :{this.props.studentDetail.classes}</h5>
            <h5>Parent :{this.props.studentDetail.parent}</h5>
            <h5>Address :{this.props.studentDetail.address}</h5>
            <h5>Phone No: {this.props.studentDetail.Phone}</h5> */}
            <div className="row">
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col">
                            <div className="cover" style={{ backgroundImage: "url(" + cover + ")" }}>
                            </div>
                            <div>
                                <div className="detail" style={{ backgroundImage: "url(" + dp + ")" }}>

                                </div>
                                <div style={{ float: "right", paddingLeft: "20px" }}>
                                    <h1>{this.props.studentDetail.name}</h1>
                                    <strong>Admission No : {this.props.studentDetail.roll}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card">
                                <table style={{ margin: "5%" }}>
                                    <tbody>
                                        <tr>
                                            <td>USERNAME</td>
                                            <td>{this.props.studentDetail.name}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>{this.props.studentDetail.Phone}</td>
                                        </tr>
                                        <tr>
                                            <td>Address</td>
                                            <td>{this.props.studentDetail.address}</td>
                                        </tr>
                                        <tr>
                                            <td>Date of Birth</td>
                                            <td>{this.props.studentDetail.dob}</td>
                                        </tr>
                                        <tr>
                                            <td>Mother's Name</td>
                                            <td>{this.props.studentDetail.motherName}</td>
                                        </tr>
                                        <tr>
                                            <td>Father's Name</td>
                                            <td>{this.props.studentDetail.parent}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            Personal Information
                    </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <label>Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.name} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Username</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.username} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>Email</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.email}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Phone</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.Phone} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>Address</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.address}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Date of Birth</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.dob} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>Father's Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.parent}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>Mother's Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.props.studentDetail.motherName} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>


        </div>);
    }
}
// const Student = (props) => {

// }
export default Student;